<template>
  <div class="features-trail">
    <div>
      <p class="features-trail_title">即刻试用易纸箱产品服务</p>
      <p class="features-trail_desc">
        AI提效+数据降本<br />
        智能管理让纸箱厂利润飙升！
      </p>
    </div>

    <div class="features-trail_action">
      <div class="action-trail" @click="trailClick">立即试用</div>
      <div class="action-example">
        <router-link to="/benchmarkExample">客户案例</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  },
  methods: {
    trailClick() {
      window.open('https://zxcerptest.cpsol.net/trial.html')
      // this.$router.push({
      //   path: '/product/freeUse'
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.features-trail {
  width: 100%;
  background-image: url('../../../assets/images/productFeatures/bg_trail.png');
  background-position: center;
  background-size: cover;
  color: #ffffff;
  height: 610px;
  text-align: center;
  &_title {
    padding-top: 64px;
    font-weight: 500;
    font-size: 40px;
    color: #ffffff;
  }
  &_desc {
    margin: 32px 0;
    font-weight: 400;
    font-size: 32px;
    color: #ffffff;
  }
  &_action {
    padding: 0 60px;
    .action-trail {
      height: 100px;
      background: #0071ef;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.07);
      // font-family: MicrosoftYaHei;
      font-size: 28px;
      color: #ffffff;

      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 32px;
      cursor: pointer;
    }
    .action-example {
      height: 100px;
      background: #ffffff;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.07);
      font-family: MicrosoftYaHei;
      font-size: 28px;
      color: #0064eb;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
@media (min-width: 751px) and (max-width: 960px) {
  .features-trail {
    height: 128px;
    display: flex;
    justify-content: center;
    align-items: center;
    .features-trail_action {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
@media (min-width: 961px) {
  .features-trail {
    height: 128px;
    display: flex;
    justify-content: center;
    align-items: center;
    &_title {
      font-size: 32px;
      padding-top: 26px;
    }
    &_desc {
      font-size: 14px;
      margin-top: 16px;
    }
    &_action {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      .action-trail {
        height: 36px;
        margin-bottom: 0px;
        margin-right: 32px;
        background: transparent;
        font-size: 14px;
        color: #ffffff;
        width: 127px;
        border: 1px solid #ffffff;
      }
      .action-example {
        height: 36px;
        background: transparent;
        font-size: 14px;
        color: #ffffff;
        width: 127px;
        a {
          color: #ffffff;
        }
      }
    }
  }
}
</style>

<style scoped></style>
